import React from 'react';
import PropTypes from 'prop-types';
import { Heading, Text, Anchor } from 'wt-ui';
import i18next from '../../translations/i18n';

/* global window */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error(error, errorInfo);
    window.newrelic.noticeError(error);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <>
          <Heading level={3}>{i18next.t('ErrorHeading')}</Heading>
          <Text>
            {i18next.t('PleaseReloadText')}{' '}
            <Anchor href={process.env.REACT_APP_CONTACT_US_URL} secondary weight="600" target="_blank">
              {i18next.t('ContactUs')}
            </Anchor>{' '}
            {i18next.t('ProblemPersists')}
          </Text>
        </>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default ErrorBoundary;
